import { theme } from 'lib/style';
import styled from 'styled-components/macro';
type RowProps = {
  justifyContent?: string;
};
export const Row = styled.div<RowProps>`
  display: flex;
  flex-direction: row;
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : 'start'};
  align-items: flex-start;
  width: 100%;
  padding: 0.5rem 0;
  @media screen and (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FieldLabel = styled.label`
  width: 120px;
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 8px;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.palette.gray60};
`;

export const SectionTitle = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  margin: 0;
  width: 100%;
  max-width: 200px;
  line-height: 24px;
`;

export const IconWrapper = styled.div`
  position: absolute;
  color: #9297a2;
  margin-top: 8px;
  margin-left: 135px;
`;

export const RowWrapper = styled.div`
  width: 100%;
  div:first-child,
  p:first-child {
    padding-top: 0px;
  }
`;

export const Container = styled.div`
  display: flex;
  max-width: 700px;
`;
